import { HanaFloatingChatLazy } from '@crehana/hana-ai/floating-chat';
import { LoadIntercom } from '@crehana/layouts/components/load-intercom.universal';
import { App, type MyAppProps } from '@crehana/next';
import { RBACProvider } from '@crehana/rbac/provider';
import smothscroll from 'smoothscroll-polyfill';

import 'nprogress/nprogress.css';
import '@crehana/next/dist/main.css';
import '@crehana/tailwindcss/dist/crehana-tailwindcss.css';
import '@crehana/ui/dist/crehana-ui.min.css';

if (typeof window !== 'undefined') {
  smothscroll.polyfill();
  // @ts-ignore
  window.__forceSmoothScrollPolyfill__ = true;
}

const CustomApp: React.FC<React.PropsWithChildren<MyAppProps>> = props => {
  return (
    <App
      {...props}
      pageProps={{
        ...props.pageProps,
        disabledShoppingCart: true,
      }}
      customRender={({ Component }) => {
        return (
          <>
            <RBACProvider>
              <Component err={props.err} {...props.pageProps} />
            </RBACProvider>
            <HanaFloatingChatLazy />
            <LoadIntercom />
          </>
        );
      }}
    />
  );
};

export default CustomApp;
